import {useContext, useMemo} from "react";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";

export function useSupportedCurrencies() {
    let {context} = useContext(GlobalContext);

    return useMemo(
        () => {
            if (context.supportedCurrencies === null) {
                return [];
            }

            return context.supportedCurrencies.map((currencyData) => {

                let locale = currencyData['locale'].replaceAll('_', '-');

                let currencySign = Intl.NumberFormat(locale, {
                    style: 'currency',
                    currencyDisplay: 'narrowSymbol',
                    currency: currencyData['code']
                })
                    .formatToParts(0)
                    .filter(part => part.type === 'currency')
                    .map(part => part.value)
                    .join('');

                return {
                    label: (currencySign === currencyData.code)
                        ? currencySign
                        : (currencySign + ' (' + currencyData.code + ')'),
                    sign: currencySign,
                    value: currencyData.code,
                    name: currencyData.name,
                    locale: locale,
                };

            });
        },
        [context.supportedCurrencies],
    );
}

export function useSupportedCurrency() {
    let supportedCurrencies = useSupportedCurrencies();

    return (currencyCode) => {
        for (let supportedCurrency of supportedCurrencies) {
            if (supportedCurrency.value === currencyCode) {
                return supportedCurrency;
            }
        }

        return null;
    }
}
